import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { NbComponentStatus, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';
import { CategoriaAssistenza } from './models';
import { RuoliUtente, Utente } from '@hm_app/@core/models/utente';
import { NgxSpinnerService } from 'ngx-spinner';
import { NbAuthService } from '@nebular/auth';
import { AuthUser } from '@hm_app/@core/models/auth_user';


@Component({
    selector: 'nb-assistenza',
    templateUrl: './hm-assistenza-component.html',
    styleUrls: ['./hm-assistenza-component.css'],
})
export class HmAssistenzaComponent implements OnInit {
    email: string;
    categoria: number;
    messaggio: string;

    form: FormGroup;

    /*     categorie = [
            { id: 'apertura_backoffice', value: 'Apertura pagina backoffice' },
            { id: 'login_cns', value: 'Login con CNS' },
            { id: 'consegna_libretto', value: 'Consegna libretto' },
            { id: 'gestione_libretto', value: 'Gestione libretto digitale' },
            { id: 'ridatazione', value: 'Ridatazione ecografica' },
            { id: 'proposte', value: 'Proposte di miglioramento' },
        ]; */

    categorie: CategoriaAssistenza[] = [];
    user: AuthUser;

    title: string;


    constructor(
        private hmService: HappyMammaService,
        private authService: NbAuthService,
        private toastrService: NbToastrService,
        private location: Location,
        private spinnerService: NgxSpinnerService
    ) {
    }

    async ngOnInit() {
        this.spinnerService.show();
        let categorieAll = await this.hmService.getCategorieAssistenza().toPromise();
        //this.categorie = categorieAll.filter(c => !c.autenticato);
        let is_auth = await this.authService.isAuthenticated().toPromise();
        if (!is_auth || this.hmService.auth_user?.isUser)
            this.title = 'Contattaci';
        else
            this.title = 'Assistenza';
        if (!is_auth) {
            this.categorie = categorieAll.filter(c => !c.autenticato);
            this.spinnerService.hide();
            return;
        }
        this.user = this.hmService.auth_user;
        this.hmService.auth_user$.subscribe((user: AuthUser) => {
            this.user = user;
            this.updateCategorie(categorieAll);
        });
        this.user = this.hmService._auth_user;
        this.updateCategorie(categorieAll);
        this.spinnerService.hide();

    }

    updateCategorie(categorieAll) {
        if (this.user?.isUser) {
            this.categorie = categorieAll.filter(c => c.utente);
        }
        else {
            this.categorie = categorieAll.filter(c => c.operatore);
        }
    }

    mandaMailAdAssistenza() {
        let categoria_object = this.categorie.find(c => c.id == this.categoria);
        this.hmService.mandaMailAdAssistenza(this.email, categoria_object.topic, this.messaggio)
            .subscribe(() => {
                this.showToast(
                    'success',
                    'Richiesta inoltrata',
                    'Richiesta di assistenza inoltrata con successo ',
                );
                this.email = this.categoria = this.messaggio = null;
                if (this.form)
                    this.form.reset();
            },

            );

    }

    private showToast(status: NbComponentStatus, title: string, body: string) {
        const position = NbGlobalLogicalPosition.BOTTOM_END;
        this.toastrService.show(body, title, { position, status });
    }
    back() {
        this.location.back();
    }
}
